import styled from 'styled-components';
import Creatable from 'react-select/creatable';

import { rem } from 'approot/shared/style';
import {
  fontFamilyBase,
  fontSize14,
  fontSize14LineHeight,
  fontWeightBold,
} from 'approot/shared/styles/typography.style';
import {
  standardInputStyles,
  StandardInputProps,
} from 'approot/shared/styles/inputs.style';
import {
  grey1,
  grey4,
  grey5,
  grey8,
  purple1,
  purple5,
  purple8,
} from 'approot/shared/styles/colours.style';
import { spacing4 } from 'approot/shared/styles/spacing.style';
import { borderRadius16 } from 'approot/shared/styles/borders.style';

// styled(Creatable) collapses react-select's generic Option type to
// `unknown`; cast back to the original generic signature to keep callers
// type-checked against their actual Option type.
export const ListSearchStyled = styled(Creatable)<StandardInputProps>`
  border: none;

  .Select__option {
    color: ${grey8};
    border-bottom: solid 1px ${grey4};
  }

  .Select__option--is-focused {
    background-color: ${purple1};
  }

  .Select__option--is-selected {
    background-color: ${purple1};
    color: ${purple8};
  }

  .Select__value-container {
    padding: 0;
  }

  .Select__multi-value {
    background-color: ${grey1};
    border: 1px solid ${grey5};
    border-radius: ${rem(borderRadius16)};
    height: ${rem(32)};
    margin: 0 ${rem(spacing4)} ${rem(spacing4)} 0;
    padding: 0;
  }

  .Select__multi-value__label {
    color: ${grey8};
    font-family: ${fontFamilyBase};
    font-size: ${rem(fontSize14)};
    line-height: ${rem(fontSize14LineHeight)};
    display: flex;
    align-items: center;
    padding: 0 ${rem(10)} 0 ${rem(12)};
  }

  .Select__multi-value__remove {
    color: ${grey8};
    cursor: pointer;
    border-radius: 0 ${rem(borderRadius16)} ${rem(borderRadius16)} 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${rem(25)};
    padding: 0;

    &:hover {
      background-color: ${purple1};
      color: ${grey8};
    }

    svg {
      width: ${rem(16)};
      height: ${rem(16)};
    }
  }

  .Select__control--is-focused {
    outline: none;
    border-color: ${purple5} !important;
    box-shadow: none;
  }

  .Select__control {
    ${standardInputStyles}
    border-radius: ${rem(40)};
    height: auto;
    padding: 0;
    flex-direction: row-reverse;
  }

  .Select__menu {
    z-index: 10;
  }

  .Select__menu-notice--no-options {
    color: ${grey8};
    font-family: ${fontFamilyBase};
    font-size: ${rem(fontSize14)};
    line-height: ${rem(fontSize14LineHeight)};
  }
` as unknown as typeof Creatable;

export const ListSearchHighlightedText = styled.span`
  font-weight: ${fontWeightBold};
  color: ${purple5};
`;
